import academicRoutes from './modules/academic'
import authRoutes from './modules/auth'
import crmRoutes from './modules/crm'
import dashboardRoutes from './modules/dashboard'
import facilityRoutes from './modules/facility'
import feedbackRoutes from './modules/feedback'
import financeRoutes from './modules/finance'
import notificationRoutes from './modules/notification'
import salaryRoutes from './modules/salary'
import scheduleVacationRoutes from './modules/schedule-vacation'
import settingsRoutes from './modules/settings'
import staffRoutes from './modules/staff'
import studentRoutes from './modules/student'
import taskRoutes from './modules/task'
import taskNewRoutes from './modules/tasknew'
import teacherRoutes from './modules/teacher'

const routes = [
  {
    path: '/',
    component: () => import('../components/layout/GuestLayout'),
    children: authRoutes,
  },
  {
    path: '/',
    component: () => import('../components/layout/MainLayout'),
    meta: {
      title: 'Trang chủ',
    },
    children: [
      ...dashboardRoutes,
      ...academicRoutes,
      ...studentRoutes,
      ...teacherRoutes,
      ...staffRoutes,
      ...financeRoutes,
      ...taskRoutes,
      ...taskNewRoutes,
      ...feedbackRoutes,
      ...settingsRoutes,
      ...facilityRoutes,
      ...salaryRoutes,
      ...notificationRoutes,
      ...crmRoutes,
      ...scheduleVacationRoutes,
      {
        path: '*',
        name: 'page404',
        component: () => import('@/views/Page404'),
        meta: {
          title: 'Page not found',
        },
      },
    ],
  },
]
export default routes
